var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-list',{staticClass:"userResourceList",attrs:{"fields":_vm.state.fields,"loading":_vm.state.loading,"list":_vm.state.list,"table-h":_vm.tableH,"show-action-col":false,"row-key":"id","showPage":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }